var _path, _circle, _path2, _circle2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposeTalentWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.4,304.8c-56.1,0-101.6,45.5-101.6,101.6v91.4c0,5.6,4.5,10.2,10.2,10.2h182.9c5.6,0,10.2-4.5,10.2-10.2v-91.4c-.1-56.1-45.6-101.6-101.7-101.6Z",
    fill: "white",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 177.8,
    r: 76.2,
    transform: "translate(-43.89 249.64) rotate(-45)",
    fill: "white",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m188.5,278.8c-17.6-29.9-49.7-50.2-86.9-50.2C45.5,228.6,0,274.1,0,330.2v91.4c0,5.6,4.5,10.2,10.2,10.2h116.8v-25.4c0-49.3,23.6-93.1,60.1-121,2-1.5,2.7-4.4,1.4-6.6Z",
    fill: "white",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.6,
    cy: 101.6,
    r: 76.2,
    fill: "white",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m497.8,50.8h-40.6V10.2c0-5.7-4.6-10.2-10.2-10.2h-30.5c-5.6,0-10.2,4.5-10.2,10.2v40.6h-40.6c-5.6,0-10.2,4.5-10.2,10.2v30.5c0,5.6,4.5,10.2,10.2,10.2h40.6v40.6c0,5.6,4.5,10.2,10.2,10.2h30.5c5.6,0,10.2-4.5,10.2-10.2v-40.6h40.6c5.6,0,10.2-4.5,10.2-10.2v-30.5c0-5.7-4.6-10.2-10.2-10.2Z",
    fill: "white",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposeTalentWhite);
export default __webpack_public_path__ + "static/media/propose-talent-white.284f7a9246270e3853764bf831720f5f.svg";
export { ForwardRef as ReactComponent };